<h1 class="page-title">
  <a routerLink="/super-admin/manage-prd-signup" class="nav-back"><i class="icon icon-arrow-left-9"></i>
    <span>Back</span></a>
</h1>

<ul class="d-flex flex-nowrap tab-bar">
  <li [ngClass]="actTab === 'basic' ? 'active-tab' : ''" (click)="activeTab('basic')"><span>Basic Info</span></li>
  <li [ngClass]="actTab === 'documents' ? 'active-tab' : ''" (click)="activeTab('attach')"><span>Documents</span></li>
  <li [ngClass]="actTab === 'timeline' ? 'active-tab' : ''" (click)="activeTab('timeline')"><span>Action TimeLine</span>
  </li>
  <li [ngClass]="actTab === 'confirmation' ? 'active-tab' : ''" (click)="activeTab('confirmation')" [hidden]="
      !(
        dataItem?.productStatus === 'Submitted' ||
        dataItem?.productStatus === 'Completed' ||
        dataItem?.productStatus === 'Approval Pending' ||
        dataItem?.productStatus === 'Approved'
      )
    ">
    <span>Confirmation</span>
  </li>
</ul>
<div class="loader" [hidden]="!prdSataInprogress">Loader</div>
<div [hidden]="prdSataInprogress">
  <section [hidden]="actTab !== 'basic'">
    <!-- <div class="float-row" [hidden]="notifiedFieldsList && notifiedFieldsList.length < 1">
      <span class="btn btn-primary cursor-pointer" (click)="sendMailToClient()">Send Email to Client</span>
    </div> -->

    <table class="table table-striped table-bordered1">
      <tbody>
        <tr>
          <td colspan="3"><b>Product Info</b></td>
        </tr>
        <tr>
          <td>Product Id</td>
          <td width="400">{{ dataItem?.productId || '' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Product Name</td>
          <td width="400">
            {{ dataItem?.productKey || '' }}
          </td>

          <td></td>
        </tr>
        <tr>
          <td>Product Status</td>
          <td width="400">
            {{ dataItem?.productStatus }}
          </td>
          <td></td>
        </tr>

        <tr
          *ngIf="dataItem?.subscriptionHistory && dataItem.subscriptionHistory.length > 1 && dataItem.productStatus === 'Re-Submitted'">
          <td>
            <h5>Submission History</h5>
          </td>
          <td width="400">
            <span *ngFor="let history of dataItem?.subscriptionHistory">{{ history }}<br /></span>
          </td>
          <td></td>
        </tr>
        <!-- <tr>
        <td><b>Add General Comment</b></td>
        <td></td>
        <td>
          <app-notify-client
            *ngIf="
              (status === 'Approval Pending' || status === 'Modifying' || status === 'Submitted' || status === 'Re-Submitted') &&
              !isMarketingStaff
            "
            [prdId]="dataItem?.productId"
            [field]="'general'"
          ></app-notify-client>
        </td>
      </tr> -->
      </tbody>
    </table>

    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('accountHolder')">
              <span> Account Holder Information</span>
              <i class="fa" [ngClass]="toggleStatus['accountHolder'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['accountHolder']">
        <tr>
          <td>BO Type</td>
          <td>{{ dataItem?.values?.boType || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr *ngIf="dataItem?.values?.boType === 'linkBo'">
          <td>BO ID</td>
          <td>{{ dataItem?.values?.boId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Account Holder Type</td>
          <td>{{ dataItem?.values?.accountHolderType || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Gender</td>
          <td>{{ dataItem?.values?.gender || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Occupation</td>
          <td>{{ dataItem?.values?.occupation || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Courtesy Title</td>
          <td>{{ dataItem?.values?.courtesyTitle || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>{{ dataItem?.values?.firstName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>{{ dataItem?.values?.lastName || 'N/A' }}</td>
          <td></td>
        </tr>

        <tr>
          <td>Date of Birth</td>
          <td>{{ dataItem?.values?.dateOfBirth | date : 'dd-MM-yyyy' || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Father's Name</td>
          <td>{{ dataItem?.values?.fathersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Mother's Name</td>
          <td>{{ dataItem?.values?.mothersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line1</td>
          <td>{{ dataItem?.values?.addressLine1 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line2</td>
          <td>{{ dataItem?.values?.addressLine2 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line3</td>
          <td>{{ dataItem?.values?.addressLine3 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>City</td>
          <td>{{ dataItem?.values?.city || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>District</td>
          <td>{{ dataItem?.values?.district || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Post Code</td>
          <td>{{ dataItem?.values?.postCode || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{ dataItem?.values?.country || 'N/A' }}</td>
          <td></td>
        </tr>

        <tr>
          <td>Mobile</td>
          <td>{{ dataItem?.values?.mobile || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Email</td>
          <td>
            {{ dataItem?.values?.email || 'N/A' }}
            <i
              class="fas fa-light check {{ dataItem?.values?.emailVerified ? 'fa-circle-check' : 'fa-circle-exclamation' }} "></i>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Telephone</td>
          <td>{{ dataItem?.values?.telephone || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Fax</td>
          <td>{{ dataItem?.values?.fax || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Nationality</td>
          <td>{{ dataItem?.values?.nationality || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>National ID</td>
          <td>{{ dataItem?.values?.nationalId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>TIN</td>
          <td>{{ dataItem?.values?.tin || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Broker Branch</td>
          <td>{{ dataItem?.values?.brockerBranch || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Residential Status</td>
          <td>{{ dataItem?.values?.residentialStatus || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Officer or Sponsor</td>
          <td>
            {{ dataItem?.values?.officerOrSponsor || 'N/A' }}
            <div *ngIf="dataItem?.values?.officerOrSponsor === 'yes'">
              <span><b>Company Name:</b> {{ dataItem?.values?.officerCompanyName || 'N/A' }}</span>
              <span><b>Designation:</b> {{ dataItem?.values?.officerDesignation || 'N/A' }}</span>
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('bank-info')">
              <span> Bank Information</span>
              <i class="fa" [ngClass]="toggleStatus['bank-info'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['bank-info']">
        <tr>
          <td>Account Number</td>
          <td>{{ dataItem?.values?.accountNumber || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Bank Name</td>
          <td>{{ dataItem?.values?.bankObject?.value || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Branch Name</td>
          <td>{{ dataItem?.values?.branchName || 'N/A' }} ({{ dataItem?.values?.branchObject?.code }})</td>
          <td></td>
        </tr>
        <tr>
          <td>Rout No</td>
          <td>{{ dataItem?.values?.bankRoutingNumber || '' }}</td>
        </tr>
        <tr>
          <td>District No</td>
          <td>{{ dataItem?.values?.bankDistrictCode || '' }}</td>
        </tr>
        <tr>
          <td>Bank District</td>
          <td>{{ dataItem?.values?.bankDistrict || 'N/A' }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('nominee-1')">
              <span> Nominee 1 Information</span>
              <i class="fa" [ngClass]="toggleStatus['no'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['nominee-1']">
        <tr>
          <td>Courtesy Title</td>
          <td>{{ dataItem?.values?.nominee1CourtesyTitle || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>{{ dataItem?.values?.nominee1FirstName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>{{ dataItem?.values?.nominee1LastName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Relation</td>
          <td>{{ dataItem?.values?.nominee1Relation || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Percentage</td>
          <td>{{ dataItem?.values?.nominee1Percentage || 'N/A' }}%</td>
          <td></td>
        </tr>
        <tr>
          <td>Residential Status</td>
          <td>{{ dataItem?.values?.nominee1ResidentialStatus || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Date of Birth</td>
          <td>{{ dataItem?.values?.nominee1DateOfBirth | date : 'dd-MM-yyyy' || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>National ID</td>
          <td>{{ dataItem?.values?.nominee1NId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line 1</td>
          <td>{{ dataItem?.values?.nominee1AddressLine1 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>City</td>
          <td>{{ dataItem?.values?.nominee1City || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Post Code</td>
          <td>{{ dataItem?.values?.nominee1PostCode || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Division</td>
          <td>{{ dataItem?.values?.nominee1Division || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{ dataItem?.values?.nominee1Country || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{{ dataItem?.values?.nominee1Email || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Mobile</td>
          <td>{{ dataItem?.values?.nominee1Mobile || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Telephone</td>
          <td>{{ dataItem?.values?.nominee1Telephone || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Fax</td>
          <td>{{ dataItem?.values?.nominee1Fax || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Father's Name</td>
          <td>{{ dataItem?.values?.nominee1FathersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Mother's Name</td>
          <td>{{ dataItem?.values?.nominee1MothersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Profession</td>
          <td>{{ dataItem?.values?.nominee1Profession || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Required</td>
          <td>{{ dataItem?.values?.nominee1Guardian ? 'Yes' : 'No' }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('nominee-1-guardian')">
              <span> Nominee 1 Guardian Information</span>
              <i class="fa" [ngClass]="toggleStatus['nominee-1-guardian'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['nominee-1-guardian']">
        <tr>
          <td>Guardian Courtesy Title</td>
          <td>{{ dataItem?.values?.nominee1GuardianCourtesyTitle || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian First Name</td>
          <td>{{ dataItem?.values?.nominee1GuardianFirstName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Last Name</td>
          <td>{{ dataItem?.values?.nominee1GuardianLastName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Relation</td>
          <td>{{ dataItem?.values?.nominee1GuardianRelation || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Percentage</td>
          <td>{{ dataItem?.values?.nominee1GuardianPercentage || 'N/A' }}%</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Residential Status</td>
          <td>{{ dataItem?.values?.nominee1GuardianResidentialStatus || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Date of Birth</td>
          <td>{{ dataItem?.values?.nominee1GuardianDateOfBirth | date : 'dd-MM-yyyy' || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian National ID</td>
          <td>{{ dataItem?.values?.nominee1GuardianNId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 1</td>
          <td>{{ dataItem?.values?.nominee1GuardianAddressLine1 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 2</td>
          <td>{{ dataItem?.values?.nominee1GuardianAddressLine2 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 3</td>
          <td>{{ dataItem?.values?.nominee1GuardianAddressLine3 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian City</td>
          <td>{{ dataItem?.values?.nominee1GuardianCity || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Post Code</td>
          <td>{{ dataItem?.values?.nominee1GuardianPostCode || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Division</td>
          <td>{{ dataItem?.values?.nominee1GuardianDivision || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Country</td>
          <td>{{ dataItem?.values?.nominee1GuardianCountry || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Email</td>
          <td>{{ dataItem?.values?.nominee1GuardianEmail || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Mobile</td>
          <td>{{ dataItem?.values?.nominee1GuardianMobile || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Telephone</td>
          <td>{{ dataItem?.values?.nominee1GuardianTelephone || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Fax</td>
          <td>{{ dataItem?.values?.nominee1GuardianFax || 'N/A' }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('nominee-2')">
              <span> Nominee 2 Information</span>
              <i class="fa" [ngClass]="toggleStatus['no'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['nominee-2']">
        <tr>
          <td>Courtesy Title</td>
          <td>{{ dataItem?.values?.nominee2CourtesyTitle || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>{{ dataItem?.values?.nominee2FirstName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>{{ dataItem?.values?.nominee2LastName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Relation</td>
          <td>{{ dataItem?.values?.nominee2Relation || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Percentage</td>
          <td>{{ dataItem?.values?.nominee2Percentage || 'N/A' }}%</td>
          <td></td>
        </tr>
        <tr>
          <td>Residential Status</td>
          <td>{{ dataItem?.values?.nominee2ResidentialStatus || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Date of Birth</td>
          <td>{{ dataItem?.values?.nominee2DateOfBirth | date : 'dd-MM-yyyy' || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>National ID</td>
          <td>{{ dataItem?.values?.nominee2NId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line 1</td>
          <td>{{ dataItem?.values?.nominee2AddressLine1 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>City</td>
          <td>{{ dataItem?.values?.nominee2City || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Post Code</td>
          <td>{{ dataItem?.values?.nominee2PostCode || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Division</td>
          <td>{{ dataItem?.values?.nominee2Division || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Country</td>
          <td>{{ dataItem?.values?.nominee2Country || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{{ dataItem?.values?.nominee2Email || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Mobile</td>
          <td>{{ dataItem?.values?.nominee2Mobile || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Telephone</td>
          <td>{{ dataItem?.values?.nominee2Telephone || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Fax</td>
          <td>{{ dataItem?.values?.nominee2Fax || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Father's Name</td>
          <td>{{ dataItem?.values?.nominee2FathersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Mother's Name</td>
          <td>{{ dataItem?.values?.nominee2MothersName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Profession</td>
          <td>{{ dataItem?.values?.nominee2Profession || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Required</td>
          <td>{{ dataItem?.values?.nominee2Guardian ? 'Yes' : 'No' }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4 (click)="sectionToggle('nominee-2-guardian')">
              <span> Nominee 2 Guardian Information</span>
              <i class="fa" [ngClass]="toggleStatus['nominee-2-guardian'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </h4>
          </th>
        </tr>
      </thead>
      <tbody [hidden]="!toggleStatus['nominee-2-guardian']">
        <tr>
          <td>Guardian Courtesy Title</td>
          <td>{{ dataItem?.values?.nominee2GuardianCourtesyTitle || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian First Name</td>
          <td>{{ dataItem?.values?.nominee2GuardianFirstName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Last Name</td>
          <td>{{ dataItem?.values?.nominee2GuardianLastName || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Relation</td>
          <td>{{ dataItem?.values?.nominee2GuardianRelation || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Percentage</td>
          <td>{{ dataItem?.values?.nominee2GuardianPercentage || 'N/A' }}%</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Residential Status</td>
          <td>{{ dataItem?.values?.nominee2GuardianResidentialStatus || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Date of Birth</td>
          <td>{{ dataItem?.values?.nominee2GuardianDateOfBirth | date : 'dd-MM-yyyy' || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian National ID</td>
          <td>{{ dataItem?.values?.nominee2GuardianNId || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 1</td>
          <td>{{ dataItem?.values?.nominee2GuardianAddressLine1 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 2</td>
          <td>{{ dataItem?.values?.nominee2GuardianAddressLine2 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Address Line 3</td>
          <td>{{ dataItem?.values?.nominee2GuardianAddressLine3 || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian City</td>
          <td>{{ dataItem?.values?.nominee2GuardianCity || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Post Code</td>
          <td>{{ dataItem?.values?.nominee2GuardianPostCode || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Division</td>
          <td>{{ dataItem?.values?.nominee2GuardianDivision || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Country</td>
          <td>{{ dataItem?.values?.nominee2GuardianCountry || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Email</td>
          <td>{{ dataItem?.values?.nominee2GuardianEmail || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Mobile</td>
          <td>{{ dataItem?.values?.nominee2GuardianMobile || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Telephone</td>
          <td>{{ dataItem?.values?.nominee2GuardianTelephone || 'N/A' }}</td>
          <td></td>
        </tr>
        <tr>
          <td>Guardian Fax</td>
          <td>{{ dataItem?.values?.nominee2GuardianFax || 'N/A' }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </section>
  <!-- Attachments Section -->
  <section [hidden]="actTab !== 'attach'">
    <table class="table table-striped table-bordered1">
      <thead>
        <tr>
          <th colspan="3">
            <h4><span>All Attachments</span></h4>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let col of dataItem && dataItem['attachments']; let i = index">
          <td>{{ col.note || 'Unknown Document' }}</td>
          <td>
            <span [id]="col['attachmentType']"></span>
            <app-pdf-preview [imgWidth]="100" [url]="col && col['url']" [downloadLink]="true"
              [attachmentName]="dataItem?.values?.nationalId + '_' + col['note']"></app-pdf-preview>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </section>
  <section *ngIf="actTab === 'timeline'">
    <h5 class="mt-4 text-center">SignUp Action TimeLine</h5>
    <div class="mb-4 text-end">
      <span class="btn btn-primary cursor-pointer" (click)="signupActionTimeline()">Refresh</span>
    </div>
    <div class="detail-block">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>User</th>
            <th width="50%">Action</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="3">
              <div [hidden]="!signUpActionInProgress" class="loader"></div>
            </td>
          </tr>

          <tr *ngFor="let row of signUpActionList">
            <td>{{ row?.user?.name }}</td>
            <td [innerHTML]="row?.action"></td>
            <td>{{ row?.time ? (row?.time | date : 'dd MMM yyyy hh:mm a') : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
  <!-- Confirmation Section -->
  <section *ngIf="actTab === 'confirmation'">
    <h4><span>Check List</span></h4>

    <div class="row col-12">
      <div class="col-12 text-end">
        <button class="btn btn-download" (click)="downloadApplication()">
          <span>Download Application</span> <span class="loader inline-loader"
            [hidden]="!downloadApplicationInProgress"></span>
        </button>
      </div>
      <div class="col-auto ms-auto text-end">
        <div class="alert alert-danger text-center" *ngIf="downloadApplicationError">
          {{ downloadApplicationError }}
        </div>
      </div>
    </div>
    <div class="row col-12">
      <div class="col-12 col-md-6">
        <form *ngIf="confirmSignupFG && !checkListInprogress" class="form" #usform="ngForm"
          [formGroup]="confirmSignupFG" (ngSubmit)="confirmSignup(usform)" novalidate>
          <div class="row form-group">
            <label class="col-12 col-md-4">Basic Information</label>
            <div class="col">
              <label>
                <input type="checkbox" name="informationChecked" formControlName="informationChecked" />
                <i class="icon" [ngClass]="{
                    'icon-check-1': confirmSignupFG.controls['informationChecked'].value && !docusignInProgress,
                    uncheck: !confirmSignupFG.controls['informationChecked'].value
                  }"></i>
              </label>
              <errors [on]="usform.touched && confirmSignupFG.get('informationChecked').invalid"> Required </errors>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-12 col-md-4">Documents</label>
            <div class="col">
              <label>
                <input type="checkbox" name="attachments" formControlName="documentsChecked" />
                <i class="icon" [ngClass]="{
                    'icon-check-1': confirmSignupFG.controls['documentsChecked'].value && !docusignInProgress,
                    uncheck: !confirmSignupFG.controls['documentsChecked'].value
                  }"></i>
              </label>
              <errors [on]="usform.touched && confirmSignupFG.get('documentsChecked').invalid"> Required </errors>
            </div>
          </div>
          <div class="row form-group">
            <label class="col-12 col-md-4">Investor Code</label>
            <div class="col">
              <input type="text" name="investorCode" formControlName="investorCode" />
              <errors [on]="usform.touched && confirmSignupFG.get('investorCode').invalid"> Required </errors>
            </div>
          </div>

          <div class="row form-group justify-content-end">
            <div class="col text-end" *ngIf="
                confirmSignupFG.get('investorCode').value &&
                confirmSignupFG.get('informationChecked').value &&
                confirmSignupFG.get('documentsChecked').value &&
                investerCodeSubmitted
              ">
              <button type="button" class="btn btn-primary" (click)="downloadFileFromUrl()">Download BO Setup
                File</button>
            </div>
            <div class="col-auto text-end">
              <button type="button" [attr.disabled]="signatureInProgress ? 'disabled' : null" class="btn btn-primary"
                (click)="downloadSignature()">
                DownLoad Signature
              </button>
            </div>
            <div class="col-auto text-end">
              <button type="submit" [attr.disabled]="usform.invalid ? 'disabled' : null" class="btn btn-primary">
                {{ dataItem?.productStatus === 'Approval Pending' ? 'Update' : 'Save' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-12" [hidden]="!dataItem?.productStatus === 'Approval Pending'">
      <h4><span>Approve Signup</span></h4>
      <div class="row col-12">
        <div class="alert alert-success text-center" *ngIf="successfullyApproved">This product has been successfully
          Approved.</div>
      </div>
      <div class="col-12">
        <div class="col-12 col-md-6">
          <div class="row form-group mt-3">
            <label class="col-12 col-md-4">BO ID</label>
            <div class="col position-relative">
              <input type="text" name="boId" [formControl]="boId" />
              <errors [on]="boId.touched && boId.invalid">
                <span *ngIf="boId.errors?.boidExistsInSystem">BOID exist in the system</span>
                <span *ngIf="boId.errors?.required">BOID is required</span>
              </errors>
              <i [hidden]="!boId.touched" class="boid-status-icon fas fa-light check {{
                  !boId.errors?.boidExistsInSystem ? 'fa-circle-check' : 'fa-circle-exclamation'
                }} "></i>
            </div>
          </div>
          <div class="row form-group justify-content-end" *ngIf="dataItem?.productStatus === 'Approval Pending'">
            <div class="col-auto text-end">
              <button class="btn btn-primary" [attr.disabled]="approvalInProgress ? 'disabled' : null"
                (click)="approveSignup()">
                Approve
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>